<template>
  <div class="d-flex justify-content-end">
    <b-button
      v-if="havePermissionToEdit"
      variant="secondary"
      size="sm"
      class="px-1 text-dark bg-transparent border-0 text-uppercase"
      :to="{ name: updateRoute, params: { id: data.item.id } }"
    >
      <font-awesome-icon :icon="icon.edit" size="lg" />
    </b-button>

    <click-confirm
      v-if="remove && havePermissionToRemove"
      class="btn btn-secondary text-dark bg-transparent border-0 btn-sm px-1 ml-1 text-uppercase"
      :messages="confirmationMessages"
      yes-class="btn btn-success"
      no-class="btn btn-danger"
      placement="left"
    >
      <template slot="confirm-yes-icon">
        <font-awesome-icon :icon="icon.thumbsUp" />
      </template>
      <template slot="confirm-no-icon">
        <font-awesome-icon :icon="icon.thumbsDown" fixed-width />
      </template>

      <div @click.stop="callRemoveItem(data.item)">
        <font-awesome-icon :icon="icon.trash" size="lg" fixed-width />
      </div>
    </click-confirm>
  </div>
</template>

<script>
import ClickConfirm from 'click-confirm'
import {
  faEdit,
  faTrashAlt,
  faThumbsUp,
  faThumbsDown,
  faListAlt
} from '@fortawesome/free-regular-svg-icons'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

export default {
  components: {
    FontAwesomeIcon,
    ClickConfirm
  },
  props: {
    data: {
      type: Object,
      required: true
    },
    updateRoute: {
      type: String,
      required: true
    },
    remove: {
      type: Boolean,
      required: false,
      default: true
    },
    havePermissionToRemove: {
      type: Boolean,
      required: false,
      default: true
    },
    havePermissionToEdit: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  data: () => ({
    icon: {
      edit: faEdit,
      trash: faTrashAlt,
      thumbsUp: faThumbsUp,
      thumbsDown: faThumbsDown,
      order: faListAlt
    },
    confirmationMessages: {
      title: 'Tem a certeza?',
      yes: 'Sim',
      no: 'Não'
    }
  }),
  methods: {
    callRemoveItem(item) {
      this.$emit('removeItem', item)
    }
  }
}
</script>
